import { useOnline } from '@/hooks/useOnline';

/**
 * Network-connectivity indicator. Renders a full-width banner when the browser
 * is offline. Separate from {@link OfflineBanner}, which surfaces auth fallback.
 *
 * Per spec §3.6: surface the offline state (fail-fast) — messages are NOT
 * silently queued; the composer disables while offline.
 */
export function ConnectivityBanner(): React.ReactElement | null {
  const isOnline = useOnline();

  if (isOnline) return null;
  return (
    <div className="border-b border-border bg-warning px-4 py-2 text-center text-sm font-medium text-background">
      ⚠ You&apos;re offline — changes can&apos;t be sent until you reconnect.
    </div>
  );
}
